import { render } from "./MainMenuItem.vue?vue&type=template&id=639617fe"
import script from "./MainMenuItem.vue?vue&type=script&lang=js"
export * from "./MainMenuItem.vue?vue&type=script&lang=js"

import "./MainMenuItem.vue?vue&type=style&index=0&id=639617fe&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__